import { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import Repo from "../../Utility/Repo";
import ModalComponent from "../../Components/ModalComponent";
import Pagination from "../../Components/Pagination";
import Loader from "../../Components/Loader";
import { TokenContext } from "../../Components/TokenContext";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";

function ListISEEUploaded(props) {
  const apiToken = useContext(TokenContext);
  const [ISEEList, setISEEList] = useState();
  const [ISEEListTemp, setISEEListTemp] = useState();
  const [loading, setLoading] = useState(true);
  const [isOpen, toggleModal] = useState(false);
  const [ISEEId, setISEEId] = useState();
  const [data, setData] = useState();

  useEffect(() => {
    loadIseeList();
  }, []);

  const loadIseeList = () => {

    setLoading(false);
    Repo.getIseeListUploaded(apiToken)
      .then((response) => {
        setISEEListTemp(response.data);
        setLoading(true);
      })
      .catch((error) => {
        console.log(error);
        setLoading(true);
      });

  }

  const deleteIsee = async () => {
    Repo.deleteIsee(apiToken, ISEEId)
      .then((response) => {
        if (response.status == 200) {
          window.location.reload();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };


  const confirmIsee = async (id) => {
    let tempData = {};
    let passedValidation = true;

    tempData["id"] = id;
    tempData["state"] = 1;

    if (passedValidation) {
      var dataJson = JSON.stringify(tempData);

      setData(dataJson);
      if (!props.apiToken) {
        toggleModal(!isOpen);
        loadIseeList();
      }
    }
  };


  const sendISEEApi = async () => {
    Repo.postConfirmIsee(apiToken, data)
      .then((response) => {
        if (response.status == 200) {
          toggleModal(false);
          loadIseeList();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };



  return (
    <>
      <div>
        <h1>Lista ISEE</h1>
        <div className="clearfix col-lg-8 py-lg-2">
          <p>Tutti gli ISEE caricati dagli utenti e non ancora validati</p>
        </div>
        <table className="table table-hover">
          <thead>
            <tr>
              <th scope="col">Dati cittadino</th>
              <th scope="col">Codice Fiscale</th>
              <th scope="col">Data caricamento</th>
              <th scope="col">Valore ISEE caricato</th>
              <th scope="col">Anno</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            {ISEEList && ISEEList.length > 0 ? (
              <>
                {ISEEList &&
                  ISEEList.map((x, index) => (
                    <tr key={index} index={index}>
                      {/* <th scope="row">{x.name}</th> */}
                      <th scope="row">
                        {x.user.firstName} {x.user.lastName}
                      </th>
                      <td>{x.user.fiscalCode.toUpperCase()}</td>
                      <td>{x.date}</td>
                      <td>
                        {x.value && parseFloat(x.value).toLocaleString("it-IT")}{" "}
                        €
                      </td>
                      <td>{x.year}</td>
                      <td className="text-right">
                        <button
                          type="button"
                          className="btn btn-outline-success p-1"
                          data-toggle="tooltip"
                          data-placement="top"
                          onClick={() => confirmIsee(x.id)}
                        >
                          <svg className="icon icon-success">
                            <use href={`${iconSprite}#it-check`}></use>
                          </svg>
                        </button>

                        <Link to={"/lista_isee/verifica_isee?idIsee=" + x.id}>
                          <button
                            className="btn btn-outline-primary p-1 ml-1"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Dettaglio"
                          >
                            <svg className="icon icon-primary">
                              <use href={`${iconSprite}#it-search`} />
                            </svg>
                          </button>
                        </Link>
                      </td>
                    </tr>
                  ))}
              </>
            ) : (
              <>
                <tr>
                  <td colSpan="6">
                    <p className="text-center m-0">
                      <b>Non ci sono ISEE da verificare.</b>
                    </p>
                  </td>
                </tr>
              </>
            )}
          </tbody>
        </table>
        {ISEEListTemp && (
          <Pagination
            items={ISEEListTemp}
            setCurrentItems={setISEEList}
            itemsPerPage={5}
          ></Pagination>
        )}
      </div>





      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header="Caricamento ISEE"
        body="Confermi di voler caricare l'ISEE?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => sendISEEApi()}
      ></ModalComponent>
      {!loading && <Loader></Loader>}
    </>
  );
}

export default ListISEEUploaded;
